// extracted by mini-css-extract-plugin
export var Adsense = "style-module--Adsense--ecfdf";
export var ContentWrapper = "style-module--ContentWrapper--8dac1";
export var Footer = "style-module--Footer--3724a";
export var FooterLogo = "style-module--FooterLogo--2a7f9";
export var Links = "style-module--Links--cb152";